<template>
  <div class="container" @click="showCategorySelection = false">
    <div class="menu" role="menu">
      <ul>
        <li>
          <router-link to="/">bioplan architekten</router-link>
        </li>
      </ul>
      <ul>
        <li>
          <router-link :to="{ name: 'Archive' }" class="active">archiv</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Office' }">büro</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Contact' }">contact</router-link>
        </li>
      </ul>

      <div class="search" role="search" v-if="!currentEntry">
        <input v-model="filterText" placeholder="suche" />
      </div>

      <div class="categories" v-if="categories" @click.stop>
        <div v-if="!showCategorySelection" @click="showCategorySelection = true">
          <span v-if="currentCategory" :style="{ color: currentCategory.color }">
            {{ currentCategory.name }}
          </span>
          <template v-else>
            alle kategorien
          </template>
          <div style="float: right; margin: 0; padding: 0;">v</div>
        </div>
        <div v-else class="category-list">
          <ul>
            <li>
              <a @click.stop="currentCategory = null; showCategorySelection = false" @mouseover="currentCategory = null">alle Kategorien</a>
            </li>
            <li v-for="c in categories">
              <a @click.stop="currentCategory = c; showCategorySelection = false" @mouseover="currentCategory = c" :style="{ color: (c === currentCategory) ? currentCategory.color : 'white' }">{{ c.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <template v-if="currentEntry">
      <div class="content">
        <div class="left font-regular">
          <h1>
            {{ currentEntry.title }}
          </h1>
          <p v-html="markedEntryText">
          </p>
        </div>

        <div class="right">
          <div :class="`image-container ${imageLayoutOption}`">
            <template v-if="imageLayoutOption == 'layout-large-only' || imageLayoutOption == 'layout-medium-only' || imageLayoutOption == 'layout-small-only' || imageLayoutOption == 'layout-large-small' || imageLayoutOption == 'layout-large-medium'">
              <img v-for="img in currentEntryImagesSorted" :src="img.url" :class="{ 'img-large': img.originalWidth >= 800, 'img-medium': img.originalWidth < 800 && img.originalWidth >= 550, 'img-small': img.originalWidth < 550 }" />
            </template>
            <template v-else>
              <!-- Large Pictures -->
              <img v-for="img in currentEntryImagesLarge" :src="img.url" class="img-large" />
              <!-- Medium & Small Pictures -->
              <div class="col-2">
                <img v-for="img in currentEntryImagesMedium" :src="img.url" class="img-medium" />
              </div>
              <div class="col-1">
                <img v-for="img in currentEntryImagesSmall" :src="img.url" class="img-small" />
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="move-left" @mouseup.left.stop="movePreviousEntry"></div>
      <div class="move-right" @mouseup.left.stop="moveNextEntry"></div>
    </template>

    <template v-else>
      <LoadingSpinner v-if="archiveLoading"></LoadingSpinner>
      <template v-else>
        <div class="archive-columns">
          <div v-for="column in columns" class="archive-column">
            <template v-for="a in column">
              <template v-if="a.noDetails">
                <div :class="{ 'flex-item': true, 'in-filter': entryInFilter(a), 'no-details': a.noDetails }"
                     :style="{ color: (entryInCurrentCategory(a)) ? currentCategory.color : 'inherit' }">
                  <div class="title">
                    {{ a.title }}
                  </div>
                  <div class="date">
                    {{ a.date | toMonthYearString }}
                  </div>
                  <div class="strikethrough"
                       :style="{ background: (entryInCurrentCategory(a)) ? currentCategory.color : (entryInFilter(a) ? 'red' : 'white') }"></div>
                  <div style="clear: both;"></div>
                </div>
              </template>
              <template v-else>
                <router-link :to="{ name: 'ArchiveEntry', params: { id: a.id } }"
                             tag="div"
                             :class="{ 'flex-item': true, 'in-filter': entryInFilter(a), 'no-details': a.noDetails }"
                             :style="{ color: (entryInCurrentCategory(a)) ? currentCategory.color : 'inherit' }">
                  <div class="title">
                    {{ a.title }}
                  </div>
                  <div class="date">
                    {{ a.date | toMonthYearString }}
                  </div>
                  <div style="clear: both;"></div>
                </router-link>
              </template>
            </template>
          </div>
        </div>
      </template>
    </template>
    <div class="information">
      <img src="../../assets/img/bioplan_signet.png" height="57" width="72" class="signet" />
    </div>
  </div>
</template>

<script>
  import LoadingSpinner from '../parts/LoadingSpinner'
  import rest from '../../services/rest'
  import marked from 'marked'

  export default {
    name: 'Archive',
    components: {
      LoadingSpinner
    },
    data () {
      return {
        archiveLoading: true,
        archive: [],
        categories: [],
        filterText: '',
        showCategorySelection: false,
        currentCategory: null,
        currentEntry: null,
        pageWidth: 0
      }
    },
    computed: {
      markedEntryText () {
        if (!this.currentEntry) { return '' }
        return marked(this.currentEntry.text, { sanitize: true, breaks: true })
      },
      currentEntryId () {
        return this.$route.params.id
      },
      currentEntryCategories () {
        if (!this.currentEntry || !this.currentEntry.categories || this.currentEntry.categories.length < 1) { return '' }
        return this.currentEntry.categories[0].name
      },
      imageLayoutOption () {
        if (!this.currentEntry.images || this.currentEntry.images.length < 1) { return 'layout-none' }
        // Bild large => originalWidth >= 800
        // Bild medium => originalWidth >= 550 && originalWidth < 800
        // Bild small => originalWidth < 550
        // Option 1: Nur Bilder large => nur Fullscreen
        // Option 2: Nur Bilder medium => 1 2/3 Spalte, von oben nach unten gefüllt
        // Option 3: Nur Bilder small => 3 Spalten, von links nach rechts, oben nach unten gefüllt
        // Option 4: Bilder small + medium => 2/3 links medium, 1/3 rechts small
        // Option 5: Bilder small + large => oben large fullscreen, darunter small links->rechts, oben->unten
        // Option 6: Bilder medium + large => oben large fullscreen, darunter medium untereinander
        // Option 7: Bilder small + medium + large => oben large fullscreen, darunter links 2/3 medium, rechts 1/3 small
        let hasLarge = (this.currentEntry.images.find((img) => { return img.size === 2 }) !== undefined)
        let hasMedium = (this.currentEntry.images.find((img) => { return img.size === 1 }) !== undefined)
        let hasSmall = (this.currentEntry.images.find((img) => { return img.size === null || img.size === 0 }) !== undefined)
        if (hasLarge && !hasMedium && !hasSmall) { return 'layout-large-only' }
        if (!hasLarge && hasMedium && !hasSmall) { return 'layout-medium-only' }
        if (!hasLarge && !hasMedium && hasSmall) { return 'layout-small-only' }
        if (!hasLarge && hasMedium && hasSmall) { return 'layout-medium-small' }
        if (hasLarge && !hasMedium && hasSmall) { return 'layout-large-small' }
        if (hasLarge && hasMedium && !hasSmall) { return 'layout-large-medium' }
        return 'layout-all'
      },
      currentEntryImagesSorted () {
        if (!this.currentEntry.images || this.currentEntry.images.length < 1) { return [] }
        return this.currentEntry.images.sort((a, b) => { return a.sortOrder - b.sortOrder })
      },
      currentEntryImagesLarge () {
        if (!this.currentEntry.images || this.currentEntry.images.length < 1) { return [] }
        return this.currentEntry.images.filter((img) => { return img.size === 2 }).sort((a, b) => { return a.sortOrder - b.sortOrder })
      },
      currentEntryImagesMedium () {
        if (!this.currentEntry.images || this.currentEntry.images.length < 1) { return [] }
        return this.currentEntry.images.filter((img) => { return img.size === 1 }).sort((a, b) => { return a.sortOrder - b.sortOrder })
      },
      currentEntryImagesSmall () {
        if (!this.currentEntry.images || this.currentEntry.images.length < 1) { return [] }
        return this.currentEntry.images.filter((img) => { return img.size === null || img.size === 0 }).sort((a, b) => { return a.sortOrder - b.sortOrder })
      },
      maxColumns () {
        if (this.pageWidth >= 1200) {
          return 4
        } else if (this.pageWidth >= 900) {
          return 3
        } else {
          return 1
        }
      },
      columns () {
        let columns = []
        for (let i = 0; i < this.maxColumns; i++) {
          columns.push([])
        }
        let entryCount = this.archive.length
        let perColumn = parseInt(entryCount / this.maxColumns)
        let remaining = entryCount - (perColumn * this.maxColumns)
        let lastItem = -1
        for (let column = 0; column < columns.length; column++) {
          // Fill per column
          let itemsInThisColumn = perColumn
          if (remaining > column) {
            itemsInThisColumn++ // In this column there is an extra item needed
          }
          for (let i = 0; i < itemsInThisColumn; i++) {
            let itemIndex = lastItem + 1
            columns[column].push(this.archive[itemIndex])
            lastItem++
          }
        }
        return columns
      }
    },
    watch: {
      currentEntryId () {
        this.currentEntryIdChanged()
      },
      filterText () {
        if (this.filterText) {
          this.currentCategory = null
        }
      },
      currentCategory () {
        if (this.currentCategory) {
          this.filterText = ''
          if (this.currentEntryId) {
            this.$router.push({ name: 'Archive' })
          }
        }
      }
    },
    methods: {
      currentEntryIdChanged () {
        if (!this.currentEntryId) {
          this.currentEntry = null
        }
        let entry = this.archive.find((a) => { return a.id === parseInt(this.currentEntryId) })
        if (!entry) {
          this.currentEntry = null
        }
        this.currentEntry = entry
      },
      loadArchive () {
        this.archiveLoading = true
        rest.entries.all((response, hasError) => {
          if (hasError) {
            return
          }
          let archive = response.body
          archive = archive.sort((a, b) => {
            return new Date(b.date) - new Date(a.date)
          })
          this.archive = archive
          this.categories = []
          this.archive.forEach((a) => {
            a.categories.forEach((c) => {
              let cat = this.categories.find((entryCategory) => {
                return entryCategory.name === c.name
              })
              if (cat === undefined) {
                this.categories.push(c)
              }
            })
          })
          this.archiveLoading = false
          this.currentEntryIdChanged()
        })
      },
      showEntry (entry) {
        if (entry.noDetails) { return }
        // this.currentEntry = entry
        this.$router.push({ name: 'ArchiveEntry', params: { id: entry.id } })
      },
      moveNextEntry () {
        if (!this.currentEntry) { return false }
        let index = this.archive.indexOf(this.currentEntry)
        if (index === this.archive.length - 1) { index = -1 }
        for (let i = index + 1; i < this.archive.length; i++) {
          let entry = this.archive[i]
          let isInCurrentCategory = true
          if (this.currentCategory) {
            isInCurrentCategory = this.entryInCurrentCategory(entry)
          }
          if (isInCurrentCategory && !entry.noDetails) {
            this.showEntry(entry)
            break
          } else {
            console.log('Nicht zulässig:', entry.title, isInCurrentCategory, entry.noDetails)
          }
          if (i === this.archive.length - 1) { i = -1 }
        }
      },
      movePreviousEntry () {
        if (!this.currentEntry) { return false }
        let index = this.archive.indexOf(this.currentEntry)
        if (index === 0) { index = this.archive.length }
        for (let i = index - 1; i >= 0; i--) {
          let entry = this.archive[i]
          let isInCurrentCategory = true
          if (this.currentCategory) {
            isInCurrentCategory = this.entryInCurrentCategory(entry)
          }
          if (isInCurrentCategory && !entry.noDetails) {
            this.showEntry(entry)
            break
          }
          if (i === 0) {
            i = this.archive.length
          }
        }
      },
      entryInFilter (entry) {
        if (!this.filterText) { return false }
        return entry.title.toLowerCase().indexOf(this.filterText.toLowerCase()) !== -1
      },
      entryInCurrentCategory (entry) {
        if (!this.currentCategory) { return false }
        let cat = entry.categories.find((c) => {
          return c.id === this.currentCategory.id
        })
        if (!cat) {
          return false
        }
        return true
      },
      setPageWidthProperty () {
        this.pageWidth = window.innerWidth
      }
    },
    mounted () {
      this.loadArchive()
      this.setPageWidthProperty()
      window.addEventListener('resize', this.setPageWidthProperty)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.setPageWidthProperty)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    padding: 25px;
    color: white;
  }
  .container .content {
    margin-bottom: 77px;
  }
  .content::after {
    content:"";
    display:block;
    clear:both;
  }
  .left a {
    color: white;
    text-decoration: none;
  }
  .left {
    float: left;
    width: calc((100% - 75px) / 4 - 25px);
  }
  .right {
    float: right;
    width: calc(100% - ((100% - 75px) / 4) - 30px);
    padding-top: 10px;
  }
  @media (max-width: 1199px) {
    .left {
      width: calc(100% / 3 - 25px);
    }
    .right {
      width: calc(100% / 3 * 2 - 20px);
    }
  }
  a {
    cursor: pointer;
  }
  .archive-column {
    float: left;
    width: 100%;
    margin-top: 40px;
    font-family: 'Courier New';
  }
  @media (min-width: 900px) and (max-width: 1199px) {
    .archive-column {
      width: calc((100% - 100px) / 3);
      margin-right: 50px;
    }
    .archive-column:nth-child(3) {
      margin-right: 0;
    }
  }
  @media (min-width: 1200px) {
    .archive-column {
      width: calc((100% - 150px) / 4);
      margin-right: 50px;
    }
    .archive-column:nth-child(4) {
      margin-right: 0;
    }
  }
  .no-details {
    position: relative;
  }
  .no-details .strikethrough {
    position: absolute;
    left: 0;
    top: 50%;
    height: 1px;
    background: white;
    width: 100%;
    display: block;
  }
  .no-details div {
    text-decoration: none;
  }
  .flex-item:hover div {
    text-decoration: underline;
  }
  .no-details:hover div {
    text-decoration: none;
    cursor: auto;
  }
  .flex-item .title {
    max-width: calc(100% - 70px);
    float: left;
  }
  .flex-item .date {
    float: right;
  }
  .flex-item {
    width: 100%;
    font-size: 11pt;
    line-height: 17.5pt;
  }
  .flex-item:not(.no-details):hover {
    cursor: pointer;
  }
  .in-filter {
    color: red !important;
  }
  .categories div {
    padding: 5px;
  }
  @media (min-width: 600px) {
    .search {
      position: absolute;
      right: 0;
      top: 25px;
    }
  }
  .search input {
    background-color: transparent;
    border: none;
    color: white;
    font-family: 'biomedium';
    -moz-appearance:    textfield;
    -webkit-appearance: textfield;
    appearance: textfield;
    width: 245px;
    font-size: 11pt;
    padding-left: 5px;
  }
  .search input:focus {
    outline: none;
    border-bottom: 1px solid white;
  }
  .search input::-webkit-input-placeholder {
    color: white;
    opacity: 1;
  }
  .search input::-moz-placeholder {
    color: white;
    opacity: 1;
  }
  .search input:-moz-placeholder {
    color: white;
    opacity: 1;
  }
  .search input:-ms-input-placeholder {
    color: white;
    opacity: 1;
  }
  .search input:-ms-input-placeholder {
    color: white;
    opacity: 1;
  }
  @media (min-width: 600px) {
    .categories {
      position: absolute;
      right: 0;
      top: 80px;
    }
  }
  .categories {
    border-top: 1px solid white;
    width: 250px;
    cursor: pointer;
    background-color: #414141;
  }
  .categories a:hover {
    text-decoration: underline;
  }
  .category-list {
    border: 1px solid white;
    border-top: 0;
    max-height: 200px;
  }
  @media (max-width: 700px) {
    .left, .right {
      float: none;
      width: 100%;
      max-width: none;
    }
  }
  .image-container img {
    width: 100%;
    margin-bottom: 25px;
  }
  .image-container .col-2, .image-container .col-1 {
    float: left;
  }
  .image-container .col-2 {
    width: calc(66% - 12px);
    padding-right: 12px;
  }
  .image-container .col-1 {
    width: calc(100% - 66% - 12px);
    padding-left: 12px;
  }
  .image-container.layout-small-only img.img-small {
    width: calc(33.33% - 25px);
    margin-right: 25px;
  }
  .image-container.layout-medium-small img.img-medium, .image-container.layout-all img.img-medium {
    width: 100%;
  }
  @media (max-width: 1250px) {
    .image-container.layout-small-only img.img-small {
      width: calc(50% - 25px);
      margin-right: 25px;
    }
    .image-container.layout-medium-small img.img-medium, .image-container.layout-all img.img-medium {
      width: 100%;
    }
  }
  @media (max-width: 950px) {
    .image-container.layout-small-only img.img-small {
      width: 100%;
      margin-right: 0;
    }
    .image-container .col-2, .image-container .col-1 {
      width: 100%;
      float: none;
      max-width: none;
    }
    .image-container .col-1 {
      padding-left: 0;
    }
    .image-container .col-2 {
      padding-right: 0;
    }
  }
  .content {
    min-height: calc(100% - 128px - 107px);
    margin-top: 25px;
    margin-bottom: -25px;
  }
  .move-left {
    position: absolute;
    left: 0;
    right: 50%;
    top: 141px;
    height: 100%;
  }
  .move-right {
    position: absolute;
    left: 50%;
    right: 0;
    top: 141px;
    height: 100%;
  }
  @media (min-width: 700px) {
    .move-left {
      display: inherit;
      z-index: 9999;
      background-color: transparent;
      position: fixed;
      left: 0;
      top: 141px;
      bottom: 107px;
      right: 50%;
      cursor: url("../../assets/img/pfeil_links_white.cur"), url("../../assets/img/pfeil_links_white.png"), pointer;
    }
    .move-right {
      display: inherit;
      z-index: 9999;
      background-color: transparent;
      position: fixed;
      left: 50%;
      top: 141px;
      bottom: 107px;
      right: 0;
      cursor: url("../../assets/img/pfeil_rechts_white.cur"), url("../../assets/img/pfeil_rechts_white.png"), pointer;
    }
  }
  @media (max-width: 700px), (max-height: 400px) {
    .search, .categories {
      display: none;
    }
    .container .content {
      margin-bottom: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// Archive.vue?269cdf0b